/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FxIdDomainEntitiesDocumentsGameDocumentVersionContentFromJSON, FxIdDomainEntitiesDocumentsGameDocumentVersionContentToJSON, } from './FxIdDomainEntitiesDocumentsGameDocumentVersionContent';
import { FxIdDomainEntitiesDocumentsDocumentAccountAcceptFromJSON, FxIdDomainEntitiesDocumentsDocumentAccountAcceptToJSON, } from './FxIdDomainEntitiesDocumentsDocumentAccountAccept';
/**
 * Check if a given object implements the FxIdDomainEntitiesDocumentsGameDocumentVersion interface.
 */
export function instanceOfFxIdDomainEntitiesDocumentsGameDocumentVersion(value) {
    if (!('Id' in value) || value['Id'] === undefined)
        return false;
    if (!('Url' in value) || value['Url'] === undefined)
        return false;
    if (!('CreatedAt' in value) || value['CreatedAt'] === undefined)
        return false;
    if (!('DocumentId' in value) || value['DocumentId'] === undefined)
        return false;
    if (!('Accepts' in value) || value['Accepts'] === undefined)
        return false;
    return true;
}
export function FxIdDomainEntitiesDocumentsGameDocumentVersionFromJSON(json) {
    return FxIdDomainEntitiesDocumentsGameDocumentVersionFromJSONTyped(json, false);
}
export function FxIdDomainEntitiesDocumentsGameDocumentVersionFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'Id': json['Id'],
        'Url': json['Url'],
        'Content': json['Content'] == null ? undefined : FxIdDomainEntitiesDocumentsGameDocumentVersionContentFromJSON(json['Content']),
        'CreatedAt': (new Date(json['CreatedAt'])),
        'DocumentId': json['DocumentId'],
        'Accepts': (json['Accepts'].map(FxIdDomainEntitiesDocumentsDocumentAccountAcceptFromJSON)),
    };
}
export function FxIdDomainEntitiesDocumentsGameDocumentVersionToJSON(json) {
    return FxIdDomainEntitiesDocumentsGameDocumentVersionToJSONTyped(json, false);
}
export function FxIdDomainEntitiesDocumentsGameDocumentVersionToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'Id': value['Id'],
        'Url': value['Url'],
        'Content': FxIdDomainEntitiesDocumentsGameDocumentVersionContentToJSON(value['Content']),
        'CreatedAt': ((value['CreatedAt']).toISOString()),
        'DocumentId': value['DocumentId'],
        'Accepts': (value['Accepts'].map(FxIdDomainEntitiesDocumentsDocumentAccountAcceptToJSON)),
    };
}
//# sourceMappingURL=FxIdDomainEntitiesDocumentsGameDocumentVersion.js.map